import { Instance } from 'mobx-state-tree';
import model from './model';
import views from './views';

const Invitation = model.views(views);

export interface IInvitation extends Instance<typeof Invitation> {}

export default Invitation;
